import styled from "styled-components";
import React from "react";
import { QUERIES } from "../contants/allConstants";
import { useTranslation } from "react-i18next";

const Layout = ({ children, openDrawer }) => {
  const { i18n } = useTranslation();

  return (
    <Wrapper dir={i18n.language === "ar" ? "rtl" : "ltr"}>{children}</Wrapper>
  );
};

const Wrapper = styled.div`
  min-height: 100vh;
  width: 100%;
  display: grid;
  grid-template-areas: "header header" "${(p) =>
      p.dir == "ltr" ? "sidebar body" : "body sidebar"}";
  grid-template-columns: 1fr 4fr;
  grid-template-rows: 60px calc(max(100vh, 100%) - 60px);

  @media (${QUERIES.tabletAndDown}) {
    grid-template-columns: 1px auto;
    position: relative;
    overflow-x: hidden;
  }
`;

export default Layout;
